
import {dom} from "@e280/sly"
import {WhenstApp} from "./dom/whenst-app/element.js"
import {WhenstTimezone} from "./dom/whenst-timezone/element.js"

dom.register({
	WhenstApp,
	WhenstTimezone,
})

